module.exports = __webpack_public_path__ + "assets/dish_type-746350.svg";